import axios from '@/utils/axios';

export const vendorsList = async () => {
 const response = await axios.get(`/inventory/vendors/dropdown`);
 return response;
}